













































import { Vue, Component, Inject } from "vue-property-decorator";
import BasketAddresses from "@/components/app/global/baskets/basket/checkout/basketAddresses.vue";
import BasketCompanies from "@/components/app/global/baskets/basket/checkout/basketCompanies.vue";
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    BasketAddresses,
    BasketCompanies
  }
})
export default class BillingDetails extends Vue {
  // Inject
  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;
  // Computed
  public get basketData() {
    return this.$basketData();
  }
  // Data
  public isBusiness = !!this.$_.get(this.basketData, "basket.company_id");
  // Methods
  public onToggle() {
    if (this.basketData.isProcessing) return;
    this.isBusiness = !this.isBusiness;
  }
}
